import * as firebase from "firebase/app";
import "firebase/auth";
import getOr from 'lodash/fp/getOr';
import findIndex from 'lodash/findIndex';
import { LocalStorage } from "../models/LocalStorage";
import { Auth } from "../models/auth";
import Env from "../environments";
import { logoutApi } from "./api";

export const setUpFirebase = () => {
  const firebaseConfig = {
    apiKey: Env.DUTY_CAST_FIREBASE_API_KEY,
    authDomain: Env.DUTY_CAST_FIREBASE_AUTH_DOMAIN,
    databaseURL: Env.DUTY_CAST_FIREBASE_DATABASE_URL,
    projectId: Env.DUTY_CAST_FIREBASE_PROJECT_ID,
    storageBucket: Env.DUTY_CAST_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: Env.DUTY_CAST_FIREBASE_MESSAGING_SENDER_ID,
  };
  firebase.initializeApp(firebaseConfig);
}

export const signInWithGoogle = (onSuccess, onError) => {
  const provider = new firebase.auth.GoogleAuthProvider();
  firebase.auth().signInWithPopup(provider).then(function (result) {
    const user = result.user;
    typeof (onSuccess) === "function" && onSuccess(user);
  }).catch(function (error) {
    typeof (onError) === "function" && onError(error);
  });
}

export const signInWithFacebook = (onSuccess, onError) => {
  const provider = new firebase.auth.FacebookAuthProvider();
  firebase.auth().signInWithPopup(provider).then(function (result) {
    const user = result.user;
    typeof (onSuccess) === "function" && onSuccess(user);
  }).catch(function (error) {
    typeof (onError) === "function" && onError(error);
  });
}

export const signInWithTwitter = (onSuccess, onError) => {
  const provider = new firebase.auth.TwitterAuthProvider();
  firebase.auth().signInWithPopup(provider).then(function (result) {
    const user = result.user;
    typeof (onSuccess) === "function" && onSuccess(user);
  }).catch(function (error) {
    typeof (onError) === "function" && onError(error);
  });
}

export const getUserInfo = (onSuccess, onError) => {
  firebase.auth().onAuthStateChanged(function (user) {
    try {
      if (user) {
        typeof (onSuccess) === "function" && onSuccess(user);
      } else {
        typeof (onError) === "function" && onError();
      }
    } catch (error) {
      typeof (onError) === "function" && onError(error);
    }
  });
}

export const getCurrentUser = () => {
  return firebase.auth().currentUser;
}

export const updateUserInfo = (data, onSuccess, onError) => {
  const user = getCurrentUser();
  if (user) {
    if (data.password) {
      updatePassword(user, data.password, function () {
        const noPassword = {
          ...data
        };
        delete data["password"];
        user.updateProfile(noPassword).then(function () {
          typeof (onSuccess) === "function" && onSuccess();
        }).catch(function (error) {
          errorReloginCheck(error);
          typeof (onError) === "function" && onError(error);
        });
      }, function (error) {
        signOut();
        typeof (onError) === "function" && onError(error);
      })
    } else {
      user.updateProfile(data).then(function () {
        typeof (onSuccess) === "function" && onSuccess();
      }).catch(function (error) {
        errorReloginCheck(error);
        typeof (onError) === "function" && onError(error);
      });
    }
  } else {
    typeof (onError) === "function" && onError();
  }
}

export const updatePassword = (user, password, onSuccess, onError) => {
  try {
    user.updatePassword(password).then(function () {
      typeof (onSuccess) === "function" && onSuccess();
    }).catch(function (error) {
      errorReloginCheck(error);
      typeof (onError) === "function" && onError(error);
    });
  } catch (error) {
    typeof (onError) === "function" && onError(error);
  }
}

window.userInfo = function () {
  return getCurrentUser();
};

const logoutLocal = (onSuccess, onError, cb) => {
  LocalStorage.logout(cb);
  firebase.auth().signOut().then(function () {
    try {
      typeof (onSuccess) === "function" && onSuccess();
    } catch (error) {
      console.error(error);
      typeof (onError) === "function" && onError(error);
    }
  }).catch(function (error) {
    console.error(error);
    typeof (onError) === "function" && onError(error);
  });
}

export const signOut = (onSuccess, onError, cb) => {
  logoutApi(function () {
    logoutLocal(onSuccess, onError, cb);
  }, function (error) {
    logoutLocal(onSuccess, onError, cb);
    console.error(error);
  });
}

export const setupRecaptcha = () => {
  if (!window.recaptchaVerifier) {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier('recaptcha', {
      'size': 'invisible',
      'callback': function (response) {
      }
    });
    return window.recaptchaVerifier;
  } else {
    return window.recaptchaVerifier;
  }
}

export const setupPhone = (phoneNumber, onSuccess, onError) => {
  const appVerifier = setupRecaptcha();
  firebase.auth().signInWithPhoneNumber(phoneNumber, appVerifier)
    .then(function (confirmationResult) {
      window.phoneNumberConfirming = phoneNumber;
      typeof (onSuccess) === "function" && onSuccess(confirmationResult);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
}

export const confirmPhone = (code, isLogin = true, onSuccess, onError) => {
  if (!isLogin) {
    return firebase.auth.PhoneAuthProvider.credential(window.confirmationResult.verificationId, code);
  } else {
    window.confirmationResult.confirm(code).then(function (result) {
      typeof (onSuccess) === "function" && onSuccess(result.user);
    }).catch(function (error) {
      errorReloginCheck(error);
      typeof (onError) === "function" && onError(error);
    });
  }
}

window.signOut = signOut;

export const addEmail = (email, password, onSuccess, onError) => {
  var credential = firebase.auth.EmailAuthProvider.credential(email, password);
  linkWithCredential(credential, onSuccess, onError);
}

export const linkWithCredential = (credential, onSuccess, onError) => {
  firebase.auth().currentUser.linkWithCredential(credential)
    .then(function (usercred) {
      typeof (onSuccess) === "function" && onSuccess(usercred.user);
    }).catch(function (error) {
      typeof (onError) === "function" && onError(error);
    });
}

export const PROVIDERS = {
  PHONE: "phone",
  EMAIL: "password",
  GOOGLE: "google.com",
  FACEBOOK: "facebook.com"
}

export const checkProvider = (user, provider) => {
  const providerData = getOr([], "providerData")(user);
  return findIndex(providerData, { providerId: provider }) !== -1;
}

export const createUserWithEmailPassword = (email, password, onSuccess, onError) => {
  firebase.auth().createUserWithEmailAndPassword(email, password).then(function (data) {
    typeof (onSuccess) === "function" && onSuccess(data.user);
  }).catch(function (error) {
    typeof (onError) === "function" && onError(error);
  });
}

export const loginWithEmailPassword = (email, password, onSuccess, onError) => {
  firebase.auth().signInWithEmailAndPassword(email, password).then(function (data) {
    typeof (onSuccess) === "function" && onSuccess(data.user);
  }).catch(function (error) {
    typeof (onError) === "function" && onError(error);
  });
}

export const resetPassword = (email, onSuccess, onError) => {
  var actionCodeSettings = {
    url: window.location.href,
    handleCodeInApp: false
  };
  firebase.auth().sendPasswordResetEmail(email, actionCodeSettings).then(function (data) {
    typeof (onSuccess) === "function" && onSuccess();
  }).catch(function (error) {
    errorReloginCheck(error);
    typeof (onError) === "function" && onError(error);
  });
}

export const changePassword = (password, onSuccess, onError) => {
  getCurrentUser().updatePassword(password).then(function () {
    typeof (onSuccess) === "function" && onSuccess();
  }).catch(function (error) {
    errorReloginCheck(error);
    typeof (onError) === "function" && onError(error);
  });
}

export const signInWithLinkedin = (onSuccess, onError) => {
  delete window.linkedinPopupHasClose;
  window.linkedinPopup = (data, error) => {
    window.linkedinPopupHasClose = true;
    if (data && data.user) {
      typeof onSuccess === "function" && onSuccess(data.user);
    } else {
      typeof onError === "function" && onError(error);
    }
  };
  const popup = window.open('/linkedin-popup.html', 'name', 'height=585,width=400');
  const timer = setInterval(function () {
    if (popup.closed) {
      clearInterval(timer);
      setTimeout(function () {
        if (!window.linkedinPopupHasClose) {
          window.linkedinPopup && window.linkedinPopup(undefined, {
            code: "auth/popup-closed-by-user",
            message: "The popup has been closed by the user before finalizing the operation."
          });
        }
      }, 100);
    }
  }, 1000);
}

export const errorReloginCheck = (error) => {
  if (error && error.code === 'auth/requires-recent-login') {
    setTimeout(() => {
      signOut(undefined, undefined, Auth.callBackLogin());
    }, 1000);
  }
}